export const campaignsProps = {
    campaigns: {
        id: "campaign-structure",
        num: "1",
        title: "Campaign Structure",
        description: "Структура кампании",
        list: ["Первичный мониторинг результатов размещения", "Структура рекламных кампаний"],
        cardLink: "/campaign-structure",
    },
    campaignReport: {
        id: "campaign-report",
        num: "2",
        title: "Campaign Report",
        description: "Отчет по кампании",
        list: ["Подробный отчет", "Схематичный график"],
        cardLink: "/campaign-report",
    },
};
